export default __webpack_public_path__ + "static/1632-06ea38c91f5e90959bfd63b3374676e7.gif";